import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AssistanceLetterauthorizationComponent } from '../../components/assistances/assistance-tickets/assistance-letterauthorization/assistance-letterauthorization.component';

import { AssistanceCasesComponent } from '../../components/assistances/assistance-cases/assistance-cases.component';
import { AssistanceCasesFormComponent } from '../../components/assistances/assistance-cases/assistance-cases-form/assistance-cases-form.component';
import { ElapsedTimeComponent } from '../../components/assistances/assistance-cases/elapsed-time/elapsed-time.component';
//import { SearchCaseComponent } from '../../components/assistances/assistance-cases/search-case/search-case.component';
import { RoutesAssistanceCases } from '../../routes/routes-assistance-cases';
import { SharedModule } from '../../modules/shared-module/shared-module.module';
import { AssistanceSurveyGraphsComponent } from '../../dashboard/assistance-survey-dashboard/assistance-survey-graphs/assistance-survey-graphs.component';
import { AssistanceSurveyDashboardComponent } from '../../dashboard/assistance-survey-dashboard/assistance-survey-dashboard.component';
import { DashboardComponent } from '../../dashboard/dashboard/dashboard.component';
import { CasefilterComponent } from '../../dashboard/dashboard/casefilter/casefilter.component';
//  import { Daterangepicker } from 'ng2-daterangepicker';
import { AssistanceBillInfoComponent } from '../../components/assistance-bills/assistance-bill-info/assistance-bill-info.component';
import { AssistanceBillsComponent } from '../../components/assistance-bills/assistance-bills.component';
//  import { CreateAssistanceBillFormComponent } from '../../components/assistance-bills/create-assistance-bill-form/create-assistance-bill-form.component';
import { ChargeAssistanceBillFormComponent } from '../../components/assistance-bills/charge-assistance-bill-form/charge-assistance-bill-form.component';
import { PayAssistanceBillFormComponent } from '../../components/assistance-bills/pay-assistance-bill-form/pay-assistance-bill-form.component';
import { EditAssistanceBillFormComponent } from '../../components/assistance-bills/edit-assistance-bill-form/edit-assistance-bill-form.component';
import { ProviderArrTimeUpdateComponent } from '../../components/assistances/assistance-tickets/provider-arr-time-update/provider-arr-time-update.component';
import { AssistanceTicketExceptionComponent } from '../../components/assistances/assistance-tickets/assistance-ticket-exception/assistance-ticket-exception.component';
import { AssistanceProviderCardComponent } from '../../components/assistances/assistance-tickets/assistance-provider-card/assistance-provider-card.component';
import { AsignUserProviderComponent } from '../../components/assistances/assistance-tickets/asign-user-provider/asign-user-provider.component';
import { ServiceConfigComponent } from '../../components/assistances/assistance-tickets/service-config/service-config.component';
import { AssistanceTicketsComponent } from '../../components/assistances/assistance-tickets/assistance-tickets.component';
import { CaseFormComponent } from 'src/app/components/assistances/assistance-tickets/case-form/case-form.component';
import { AssistanceTicketsFormComponent } from '../../components/assistances/assistance-tickets/assistance-tickets-form/assistance-tickets-form.component';
import { AssistanceTicketsStepComponent } from '../../components/assistances/assistance-tickets/assistance-tickets-step/assistance-tickets-step.component';
import { ElapsedticketTimeComponent } from '../../components/assistances/assistance-tickets/elapsedticket-time/elapsedticket-time.component';
import { AssistanceTicketsCommentComponent } from '../../components/assistances/assistance-tickets/assistance-tickets-comment/assistance-tickets-comment.component';
import { AssistanceTicketInformationComponent } from '../../components/assistances/assistance-tickets/assistance-tickets-step/assistance-ticket-information/assistance-ticket-information.component';
import { CancelTicketsFormComponent } from '../../components/assistances/assistance-tickets/cancel-tickets-form/cancel-tickets-form.component';
import { AssistanceReassignProviderComponent } from '../../components/assistances/assistance-tickets/assistance-reassign-provider/assistance-reassign-provider.component';

import { ProgressbarTimerComponent } from '../../components/progressbar-timer/progressbar-timer.component';
import { ProgressbarTimerNegativeComponent } from '../../components/progressbar-timer-negative/progressbar-timer-negative.component';
import { DialogModule } from 'primeng/dialog';
import { PaginatorModule } from 'primeng/paginator';
// import { GMapModule } from 'primeng/gmap';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ListboxModule } from 'primeng/listbox';
import { ColorPickerModule } from 'primeng/colorpicker';
import { TabsModule } from 'primeng/tabs';
import { SliderModule } from 'primeng/slider';
import { ChartModule } from 'primeng/chart';
import { AccordionModule } from 'primeng/accordion';
import { MultiSelectModule } from 'primeng/multiselect';
import { SplitButtonModule } from 'primeng/splitbutton';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressBarModule } from 'primeng/progressbar';
import { ChipModule } from 'primeng/chip';
import { InplaceModule } from 'primeng/inplace';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MessageModule } from 'primeng/message';
import { AssistanceCaseTimesComponent } from 'src/app/components/assistances/assistance-cases/assistance-case-times/assistance-case-times.component';
import { AssistanceCaseTimesPopUpComponent } from 'src/app/components/assistances/assistance-cases/assistance-case-times-pop-up/assistance-case-times-pop-up.component';
import { AssistanceCasesAssignmentComponent } from 'src/app/components/assistances/assistance-cases-assignment/assistance-cases-assignment.component';
//---agrego este nuevo componente
import { AssistanceReassignViewProviderComponent } from 'src/app/components/assistances/assistance-tickets/assistance-reassign-view-provider/assistance-reassign-view-provider.component';
import { TemporalTransactionsComponent } from 'src/app/components/temporal-transactions/temporal-transactions.component';
import { CreateTemporalTransactionComponent } from 'src/app/components/create-temporal-transaction/create-temporal-transaction.component';
import { ImportComponent } from 'src/app/components/import/import.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FileUploadV2Component } from 'src/app/components/file-upload-v2/file-upload-v2.component';
@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    RoutesAssistanceCases,
    SharedModule,
    ToggleSwitchModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DialogModule,
    ConfirmDialogModule,
    PaginatorModule,
    ToastModule,
    AutoCompleteModule,
    ButtonModule,
    // GMapModule,
    InputTextModule,
    MultiSelectModule,
    SplitButtonModule,
    OverlayModule,
    PopoverModule,
    CheckboxModule,
    DatePickerModule,
    SelectModule,
    TooltipModule,
    ProgressBarModule,
    ListboxModule,
    ColorPickerModule,
    TabsModule,
    ChipModule,
    SliderModule,
    InplaceModule,
    ChartModule,
    // Daterangepicker,
    TreeModule,
    DrawerModule,
    TreeTableModule,
    DialogModule,
    PaginatorModule,
    // GMapModule,
    AccordionModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    MessageModule,
    InfiniteScrollModule,
  ],
  exports: [ProgressbarTimerComponent, ImportComponent],
  declarations: [
    AssistanceBillsComponent,
    EditAssistanceBillFormComponent,
    // CreateAssistanceBillFormComponent,
    ChargeAssistanceBillFormComponent,
    PayAssistanceBillFormComponent,
    AssistanceProviderCardComponent,
    AsignUserProviderComponent,
    AssistanceTicketExceptionComponent,
    ProviderArrTimeUpdateComponent,
    FileUploadV2Component,
    ServiceConfigComponent,
    CancelTicketsFormComponent,
    AssistanceTicketInformationComponent,
    AssistanceTicketsCommentComponent,
    AssistanceTicketsStepComponent,
    ElapsedticketTimeComponent,
    AssistanceReassignProviderComponent,
    AssistanceTicketsComponent,
    CaseFormComponent,
    AssistanceTicketsFormComponent,
    AssistanceBillInfoComponent,
    CasefilterComponent,
    DashboardComponent,
    AssistanceSurveyDashboardComponent,
    AssistanceSurveyGraphsComponent,
    ProgressbarTimerComponent,
    AssistanceCasesComponent,
    AssistanceCasesFormComponent,
    ElapsedTimeComponent,
    AssistanceCaseTimesComponent,
    AssistanceCaseTimesPopUpComponent,
    AssistanceCasesAssignmentComponent,
    ProgressbarTimerNegativeComponent,
    AssistanceReassignViewProviderComponent,
    AssistanceLetterauthorizationComponent,
    TemporalTransactionsComponent,
    CreateTemporalTransactionComponent,
    ImportComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssistanceCasesModule { }
